var backdrop = tokens => ({
  container: {
    backgroundColor: tokens.colors.neutral[90],
    opacity: tokens.opacity.xl
  }
});
export default backdrop;